import React from 'react'
import PropTypes from 'prop-types'

import WidthContainer from 'components/layout/WidthContainer/WidthContainer'

import FooterMain from './FooterMain/FooterMain'
import FooterAboutUs from './FooterAboutUs/FooterAboutUs'
import FooterShop from './FooterShop/FooterShop'
import FooterFollowUs from './FooterFollowUs/FooterFollowUs'
import FooterBottomSection from './FooterBottomSection/FooterBottomSection'

import s from './ExceptMobile.scss'


const FooterExceptMobile = ({ about, shop, collectEmailFormNode, logoLink, isAddressVisible, isLandings }) => (
  <WidthContainer className={s.exceptMobile}>
    <div className={s.content}>
      <div className={s.column}>
        <FooterMain logoLink={logoLink} isLandings={isLandings} />
      </div>
      <div className={s.column}>
        <FooterAboutUs {...about} />
      </div>
      <div className={s.column}>
        <FooterShop {...shop} />
      </div>
      <div className={s.column}>
        <FooterFollowUs collectEmailFormNode={collectEmailFormNode} />
      </div>
    </div>
    <FooterBottomSection isAddressVisible={isAddressVisible} />
  </WidthContainer>
)

FooterExceptMobile.propTypes = {
  about: PropTypes.object.isRequired,
  shop: PropTypes.object.isRequired,
  collectEmailFormNode: PropTypes.node,
  logoLink: PropTypes.string,
  isAddressVisible: PropTypes.bool,
}


export default FooterExceptMobile
